import { gql } from '@apollo/client';

export const GET_SMART_FORM_DEFINITIONS = gql`
  query GetSmartFormDefinitions {
    smartFormDefinitions {
      items {
        type
      }
    }
  }
`;
